export default __webpack_public_path__ + "media/share/map-expand@2x-2519a898.png";